import { useRef, useState } from "react";
import CircularProgress from "./CircularProgress";
import "./uploader.css";
import { GetImages } from "../../../utils/GetImages";
import CustomInputs from "../Inputs";
import { useError } from "../../../utils/context/ErrorContext";
import apiHelper from "../../../utils/apiHelper";
import { DocumentService } from "@propertelligent/client-api";

const Uploader = ({
  name,
  setMainImage,
  mainImage,
  setFileName,
  progress,
  setProgress,
  Size,
  className = "d-flex gap-3",
  documentId = null,
  EntityTypeId = null,
  EntityId = null,
  DocumentTypeId = null,
  organization = false,
  containerClassName = "d-contents",
  isFatchDetails = null,
  isFatchData = null,
  setDocumentId = (arg) => { }

}) => {
  const [loading, setLoading] = useState(false);
  const { errors, errorMessages, setErrors } = useError();
  const img = mainImage instanceof Blob ? URL.createObjectURL(mainImage) : mainImage;
  const fileInputRef = useRef<HTMLInputElement>(null);
  const clearProgress = () => {
    const interval = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? clearInterval(interval) : prevProgress + 10
      );
    }, 100);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file || !["image/png", "image/jpeg", "image/jpg"].includes(file.type)) {
      setErrors({ ...errors, ImageType: true })
      return;
    }

    const maxSize = 1 * 1024 * 1024;
    if (file.size > maxSize) {
      setErrors({ ...errors, ImageType: false, ImageSize: true })
      return;
    }

    setLoading(true);
    setErrors({ ...errors, ImageType: false, ImageSize: false })
    clearProgress();

    setTimeout(() => {
      setLoading(false);
      setMainImage(new Blob([file], { type: "image/png|jpg" }));
      setFileName(file.name);
    }, 2000);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleDelete = (documentId) => {
    if (documentId) {
      apiHelper(DocumentService.deleteApiDocument, { showNotification: false }, documentId)
        .then((res) => {
          if (res?.data?.success) {
            setMainImage(null);
            setFileName(null);
            setProgress(0);
            setDocumentId(null)
            if (isFatchDetails != null) isFatchDetails();
            if (isFatchData != null) isFatchData();
          }
        })
    }
    setMainImage(null);
    setFileName(null);
    setProgress(0);
  };

  return (
    <div className={`uploaderContainer ${className}`}>
      <div className={containerClassName}>
        <div className={`box ${Size.size}`}>
          <CustomInputs
            type="file"
            ref={fileInputRef}
            id="upload"
            myClassName="upload-input"
            name="fileName"
            placeholder={name}
            onImageUpload={handleImageUpload}
            onChange={undefined}
          />
          {loading ? (
            <div className="d-flex flex-column align-items-center gap-2">
              <CircularProgress
                size={Size.pSize}
                thickness={2}
                color="blue"
                progress={progress}
                uploadImage={Size.uploadimage}
              />
              <p className="sub_text fw-500 blue">Uploading...</p>
            </div>
          ) : mainImage ? (
            <img
              src={img}
              alt=""
              className={`${Size.size}`}
            />
          ) : (
            <label htmlFor="upload" className="upload-label">
              <div className="emptyImage">
                <img
                  className={Size.iconSize}
                  src={GetImages.BlueAdd}
                  alt="add"
                />
                <div className="sub_text fw-500 blue">{name}</div>
              </div>
            </label>
          )}
        </div>

        {mainImage ? (
          <>
            <div className="deletereplacemain">
              <div onClick={() => {
                setMainImage(null);
                setFileName(null)
              }} className="deletereplace">
                <img src={GetImages.BlueReplace} className="iconstyle" alt='' />
                <p className="replace">Replace</p>
              </div>
              <div>
                <div className="dividerSmallDiv"></div>
              </div>
              <div onClick={() => handleDelete(documentId)} className="deletereplace">
                <img src={GetImages.deleteIconRed} className="iconstyle" alt='' />
                <p className="delete">Delete</p>
              </div>
            </div>
          </>
        ) : (
          <p className="sub_text grey_subtext1">
            Image format jpeg and png. Max image size 1 MB
          </p>
        )}
      </div>

      {(errors.ImageType || errors.ImageSize) && (
        <div style={{ marginTop: "8px" }}>
          {errors.ImageType && (
            <p className="errorMessageStyles">{errorMessages.ImageType}</p>
          )}
          {errors.ImageSize && (
            <p className="errorMessageStyles">{errorMessages.ImageSize}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default Uploader;